import _Button from '@design-system/components/atoms/Button/_Button'
import { typo } from '@design-system/styles'
import styled from '@emotion/styled'
import s3URL from '@mathflat/common/util/s3'
import qs from 'qs'
import type { ComponentProps } from 'react'
import { generatePath, useHistory } from 'react-router'

import { Icon } from '@/component/atoms/Icon'
import { RouteName } from '@/router'

const CustomPrintModalBanner = ({ onClick }: ComponentProps<'div'>) => {
  const history = useHistory()
  return (
    <S.CustomPrintModalBanner
      className="custom-print-banner"
      onClick={(e) => {
        history.push({
          pathname: generatePath(RouteName.customPrint),
          search: qs.stringify({
            entryPath: history.location.pathname,
          }),
        })
        onClick?.(e)
      }}
    >
      <div className="main-container">
        <img
          width={118}
          src={s3URL.mathflatAssetsBucket.teacher(
            'images/line-banner/custom-print-line-banner-in-modal@2x.png',
          )}
          srcSet={`
          ${s3URL.mathflatAssetsBucket.teacher('images/line-banner/custom-print-line-banner-in-modal@3x.png')} 3x
        `}
          alt="커스텀 프린팅 메인 이미지"
        />
        <div className="main-text">
          <p>PDF만 올리면 고퀄리티 책으로 만들어서 배송까지!</p>

          <_Button.Text size="s" className="cta-button">
            바로가기
            <Icon name="chevron_right" color="var(--Colors-Yellow-200)" style={{ marginLeft: 2 }} />
          </_Button.Text>
        </div>
      </div>
    </S.CustomPrintModalBanner>
  )
}

export default CustomPrintModalBanner

const S = {
  CustomPrintModalBanner: styled.div`
    width: 100%;
    height: 46px;
    flex-shrink: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;
    background-color: var(--Colors-Lime-600);
    color: #fff;
    ${typo.body01};
    font-weight: 600;
    padding-left: 5px;
    cursor: pointer;

    .main-container {
      display: flex;
      align-items: center;
    }

    .main-text {
      display: flex;
      align-items: center;
      gap: 10px;
      white-space: nowrap;
    }

    .cta-button .inner-button {
      color: var(--Colors-Yellow-200);
      white-space: nowrap;
    }
  `,
}
